import { HeatData, PoolInfo } from "../context/types";
import { calculateHeatDemandOrLoss } from "./calculateHeatDemandOrLoss";
import { calculateSurfaceHeatLoss } from "./calculateSurfaceHeatLoss";

export const calculateHeat = ({
  info,
  monthTemperatureByCity,
  surfaceAreaTop,
}: {
  info: PoolInfo;
  monthTemperatureByCity: number[];
  surfaceAreaTop: number;
}): HeatData => {
  const heatDemandLoss: number[] = [];
  const heatSurfaceLoss: number[] = [];

  for (var i = 1; i < 13; i++) {
    var temp = monthTemperatureByCity?.[i];
    var heatSurfaceLostMonthly: any, heatDemandLossMonthly;

    if (temp <= 0 || temp >= info.requirePoolTemp) {
      heatSurfaceLostMonthly = 0;
      heatDemandLossMonthly = 0;

      heatDemandLoss.push(heatDemandLossMonthly);
      heatSurfaceLoss.push(heatSurfaceLostMonthly);
    } else {
      heatSurfaceLostMonthly = calculateSurfaceHeatLoss({
        poolInfo: info,
        monthTemp: temp,
        surfaceAreaTop,
      });

      heatDemandLossMonthly = calculateHeatDemandOrLoss({
        poolInfo: info,
        surfaceHeatLoss: heatSurfaceLostMonthly,
        surfaceArea: surfaceAreaTop,
      });
      heatDemandLoss.push(Number(heatDemandLossMonthly.toFixed(2)));
      heatSurfaceLoss.push(Number(heatSurfaceLostMonthly.toFixed(2)));
    }
  }

  return { heatDemandLoss, heatSurfaceLoss };
};
